import React from 'react';
import PropTypes from 'prop-types';
import issueIcons from '../Shared/IssueIcons';

const DefaultVolunteerLogo = props => {
    switch (props.issueId) {
        case 1:
            return issueIcons.education;
        case 2:
            return issueIcons.emergencyResponse;
        case 3:
            return issueIcons.environment;
        case 4:
            return issueIcons.health;
        case 5:
            return issueIcons.lgbtq;
        case 6:
            return issueIcons.migration;
        case 7:
            return issueIcons.politics;
        case 8:
            return issueIcons.poverty;
        case 9:
            return issueIcons.racialJustice;
        case 10:
            return issueIcons.safety;
        case 11:
            return issueIcons.socialJustice;
        case 12:
            return issueIcons.womensRights;
        default:
            return (
                <svg id="vmlogo" viewBox="0 0 70 60" width="100%" height="100%">
                    <path
                        fill="#11BBEE"
                        d="M66.41 18.7c0-1.88-1.52-3.4-3.4-3.4 -1.88 0-3.41 1.52-3.41 3.4v12.8c0 0.47-0.38 0.85-0.85 0.85 -0.47 0-0.85-0.38-0.85-0.85V6.8c0-1.88-1.52-3.4-3.4-3.4 -1.88 0-3.41 1.52-3.41 3.4v21.2c0 0.47-0.38 0.85-0.85 0.85 -0.47 0-0.85-0.38-0.85-0.85V3.4c0-1.88-1.52-3.4-3.4-3.4 -1.88 0-3.41 1.52-3.41 3.4v24.6c0 0.47-0.38 0.85-0.85 0.85 -0.47 0-0.85-0.38-0.85-0.85V8.5c0-1.88-1.52-3.4-3.4-3.4 -1.88 0-3.41 1.52-3.41 3.4v25.48l1.64-1.63c0.96-0.96 2.24-1.49 3.6-1.49 1.36 0 2.64 0.53 3.6 1.49 1.98 1.98 1.98 5.2 0 7.18l-9.68 9.67 4.24 4.24c3.07 3.07 7.31 4.96 12 4.96 9.37 0 16.96-7.58 16.96-16.93V18.7z"
                    />
                    <path
                        fill="#77CC44"
                        d="M0 18.7c0-1.88 1.52-3.4 3.41-3.4 1.88 0 3.41 1.52 3.41 3.4v12.8c0 0.47 0.38 0.85 0.85 0.85 0.47 0 0.85-0.38 0.85-0.85V6.8c0-1.88 1.53-3.4 3.41-3.4 1.88 0 3.41 1.52 3.41 3.4v21.2c0 0.47 0.38 0.85 0.85 0.85 0.47 0 0.85-0.38 0.85-0.85V3.4c0-1.88 1.52-3.4 3.41-3.4 1.88 0 3.41 1.52 3.41 3.4v24.6c0 0.47 0.38 0.85 0.85 0.85s0.85-0.38 0.85-0.85V8.5c0-1.88 1.52-3.4 3.41-3.4 1.88 0 3.41 1.52 3.41 3.4v25.48l-1.64-1.63c-0.96-0.96-2.24-1.49-3.6-1.49 -1.36 0-2.64 0.53-3.6 1.49 -1.98 1.98-1.98 5.2 0 7.18l9.68 9.67 -4.24 4.24c-3.07 3.07-7.31 4.96-12 4.96C7.59 58.4 0 50.82 0 41.47V18.7z"
                    />
                    <path
                        fill="#FFFFFF"
                        d="M33.2 49.19l-9.68-9.67c-1.98-1.98-1.98-5.2 0-7.18 0.96-0.96 2.24-1.49 3.6-1.49 1.36 0 2.64 0.53 3.6 1.49l2.49 2.48 2.49-2.48c0.96-0.96 2.24-1.49 3.6-1.49 1.36 0 2.64 0.53 3.6 1.49 1.98 1.98 1.98 5.2 0 7.18L33.2 49.19z"
                    />
                    <path
                        fill="#FF5533"
                        d="M42.08 38.73c1.54-1.54 1.54-4.04 0-5.58s-4.05-1.54-5.59 0l-3.29 3.28 -3.29-3.28c-1.54-1.54-4.05-1.54-5.59 0 -1.54 1.54-1.54 4.04 0 5.58l8.88 8.86L42.08 38.73z"
                    />
                </svg>
            );
    }
};

DefaultVolunteerLogo.propTypes = {
    issueId: PropTypes.number
};

export default DefaultVolunteerLogo;
